import { useGroomMode } from "../../context/GroomModeContext";
import GroomNote from "./GroomNote";
import { SCHEDULE_EVENTS } from "../../constants/siteContent";

function splitTime(time) {
  if (time === "TBD") return { value: "TBD", meridiem: null };
  const [value, meridiem] = time.split(" ");
  return { value, meridiem };
}

export default function Schedule() {
  const groomMode = useGroomMode();

  return (
    <section id="schedule" className="schedule" aria-labelledby="schedule-heading">
      <div className="section-inner section-inner--narrow">
        <h2 id="schedule-heading" className="section-heading">
          {groomMode ? "Matt's Version of The Day" : "The Day"}
        </h2>
        <p className="section-lead">
          {groomMode
            ? "The official schedule, plus what's actually going through my head."
            : "A little guide to celebrations ahead."}
        </p>

        <ol className="schedule-timeline">
          {SCHEDULE_EVENTS.map((event, index) => {
            const isTbd = event.time === "TBD";
            const { value, meridiem } = splitTime(event.time);
            const frame = index % 2 === 0 ? "sage" : "navy";

            return (
              <li key={event.time + event.title} className="schedule-item">
                <div className={`schedule-tile schedule-tile--${isTbd ? "disabled" : frame}`}>
                  <div className="schedule-tile-inner">
                    <span className="schedule-tile-value">{value}</span>
                    {meridiem && <span className="schedule-tile-meridiem">{meridiem}</span>}
                  </div>
                </div>
                <div className="schedule-item-body">
                  <h3 className="schedule-item-title">{event.title}</h3>
                  <p className="schedule-item-desc">{event.description}</p>
                  {groomMode && <GroomNote note={event.groom} />}
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
